module.exports = __webpack_public_path__ + "media/Alert 4.5610aa2d.mp3";